export default __webpack_public_path__ + "static/media/home-service-logo-left.27f358f0.svg";